import React from 'react';
import { CustomFieldsForm } from '../../../components/CustomFields';
export const CustomFieldsComponent = (props: any) => <CustomFieldsForm {...props} />;
